import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Spinner from '../../shared/spinner';
import { Parametros } from '../../shared/model/parametros';
import ParametrosService from '../../services/parametrosService';
import CustomAlert from '../../shared/customAlert';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { BackOfficeEnum } from '../../shared/constantes/backofficeEnum';
import { ProcessadoraCartaoEnum } from '../../shared/constantes/processadoraCartaoEnum';
import OriginadorService from '../../services/originadorService';
import { ProtectedAction } from '../../AccessControl';
import { Originador } from '../../shared/model/originador';

function ParametrosTi() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(true);
  const [parametros, setParametros] = useState<Parametros>();

  const [nomeBancoBpo, setNomeBancoBpo] = useState('');
  const [urlBpo, setUrlBpo] = useState('');
  const [usuarioBpo, setUsuarioBpo] = useState('');
  const [senhaBpo, setSenhaBpo] = useState('');
  const [urlDigitalBpo, setUrlDigitalBpo] = useState('');
  const [urlLecca, setUrlLecca] = useState('');
  const [tokenLecca, setTokenLecca] = useState('');
  const [urlVortx, setUrlVortx] = useState('');
  const [tokenVortx, setTokenVortx] = useState('');
  const [urlCessao, setUrlCessao] = useState('');
  const [tokenCessao, setTokenCessao] = useState('');

  // S3 Original
  const [integraS3, setIntegraS3] = useState(false);
  const [accessKeyS3, setAccessKeyS3] = useState('');
  const [secretKeyS3, setSecretKeyS3] = useState('');
  const [bucketS3, setBucketS3] = useState('');
  const [pastaDocumentosS3, setPastaDocumentosS3] = useState('');
  const [pastaComunicadosS3, setPastaComunicadosS3] = useState('');
  const [localizacaoS3, setLocalizacaoS3] = useState('');

  // Novos estados: Enum e S3 Gabarito
  const [tipoIntegracaoSecuritizadora, setTipoIntegracaoSecuritizadora] = useState('');
  const opcoesSecuritizadora = [
    { value: 'VORTX', label: 'Vortx' },
    { value: 'GABARITO', label: 'Gabarito' }
  ];
  const [accessKeyGabaritoS3, setAccessKeyGabaritoS3] = useState('');
  const [secretKeyGabaritoS3, setSecretKeyGabaritoS3] = useState('');
  const [bucketGabaritoS3, setBucketGabaritoS3] = useState('');
  const [pastaDocumentosGabaritoS3, setPastaDocumentosGabaritoS3] = useState('');
  const [pastaComunicadosGabaritoS3, setPastaComunicadosGabaritoS3] = useState('');
  const [localizacaoGabaritoS3, setLocalizacaoGabaritoS3] = useState('');

  // Novos estados: Dados Bancarizadora Gabarito
  const [cnpjBancarizadoraGabarito, setCnpjBancarizadoraGabarito] = useState('');
  const [nomeBancarizadoraGabarito, setNomeBancarizadoraGabarito] = useState('');
  const [agioOriginadorGabarito, setAgioOriginadorGabarito] = useState<number | ''>('');
  const [custoTedGabarito, setCustoTedGabarito] = useState<number | ''>('');
  const [taxaBancarizadoraGabarito, setTaxaBancarizadoraGabarito] = useState<number | ''>('');

  const [idOriginador, setIdOriginador] = useState<number | string>('');
  const [originadoresList, setOriginadoresList] = useState<any[]>([]);
  const [chaveApiPh3a, setChaveApiPh3a] = useState('');
  const [serviceAccountIss, setServiceAccountIss] = useState('');
  const [urlDeAutenticacao, setUrlDeAutenticacao] = useState('');
  const [urlApi, setUrlApi] = useState('');
  const originadorService: OriginadorService = new OriginadorService();
  const [backoffice, setBackoffice] = useState('');
  const backofficeEnum = BackOfficeEnum;

  const [processadoraCartao, setProcessadoraCartao] = useState('');
  const processadoraCartaoEnum = ProcessadoraCartaoEnum;

  const [loginCpf, setLoginCpf] = useState<number>(0);

  const [usuarioFuncao, setUsuarioFuncao] = useState('');
  const [usuarioBigdata, setUsuarioBigdata] = useState('');
  const [senhaBigdata, setSenhaBigdata] = useState('');

  const parametrosService: ParametrosService = new ParametrosService();

  const { REACT_APP_PERFIL } = process.env;

  const listarTodosParametrosTi = async () => {
    try {
      setLoading(true);
      const responseList = await parametrosService.listarTodosParametros();
      const json = responseList.data;

      setParametros(json);
      setNomeBancoBpo(json.nomeBancoBpo);
      setUrlBpo(json.urlBpo);
      setUsuarioBpo(json.usuarioBpo);
      setSenhaBpo(json.senhaBpo);
      setUrlDigitalBpo(json.urlDigitalBpo);
      setUrlLecca(json.urlLecca);
      setTokenLecca(json.tokenLecca);
      setUrlVortx(json.urlVortx);
      setTokenVortx(json.tokenVortx);
      setUrlCessao(json.urlCessao);
      setTokenCessao(json.tokenCessao);

      setIntegraS3(json.integraS3);
      setAccessKeyS3(json.accessKeyS3);
      setSecretKeyS3(json.secretKeyS3);
      setBucketS3(json.bucketS3);
      setPastaDocumentosS3(json.pastaDocumentosS3);
      setPastaComunicadosS3(json.pastaComunicadosS3);
      setLocalizacaoS3(json.localizacaoS3);

      // Carregando dados do Gabarito
      setTipoIntegracaoSecuritizadora(json.tipoIntegracaoSecuritizadora || '');
      setAccessKeyGabaritoS3(json.accessKeyGabaritoS3 || '');
      setSecretKeyGabaritoS3(json.secretKeyGabaritoS3 || '');
      setBucketGabaritoS3(json.bucketGabaritoS3 || '');
      setPastaDocumentosGabaritoS3(json.pastaDocumentosGabaritoS3 || '');
      setPastaComunicadosGabaritoS3(json.pastaComunicadosGabaritoS3 || '');
      setLocalizacaoGabaritoS3(json.localizacaoGabaritoS3 || '');

      // Carregando dados da Bancarizadora
      setCnpjBancarizadoraGabarito(json.cnpjBancarizadoraGabarito || '');
      setNomeBancarizadoraGabarito(json.nomeBancarizadoraGabarito || '');
      setAgioOriginadorGabarito(json.agioOriginadorGabarito !== undefined && json.agioOriginadorGabarito !== null ? json.agioOriginadorGabarito : '');
      setCustoTedGabarito(json.custoTedGabarito !== undefined && json.custoTedGabarito !== null ? json.custoTedGabarito : '');
      setTaxaBancarizadoraGabarito(json.taxaBancarizadoraGabarito !== undefined && json.taxaBancarizadoraGabarito !== null ? json.taxaBancarizadoraGabarito : '');

      setUsuarioBigdata(json.usuarioBigdata);
      setSenhaBigdata(json.senhaBigdata);

      setBackoffice(json.backoffice);
      setProcessadoraCartao(json.processadoraCartao);

      if (json.login_cpf !== undefined && json.login_cpf !== null) {
        setLoginCpf(json.login_cpf);
      }

      setIdOriginador(json.idOriginador);
      setChaveApiPh3a(json.chaveApiPh3a);
      setServiceAccountIss(json.serviceAccountIss);
      setUrlDeAutenticacao(json.urlDeAutenticacao);
      setUrlApi(json.urlApi);

      setUsuarioFuncao(json.usuarioFuncao);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      console.error(err.response?.data || err.message);
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      let parametros: any = new Parametros();
      parametros.nomeBancoBpo = nomeBancoBpo;
      parametros.urlBpo = urlBpo;
      parametros.usuarioBpo = usuarioBpo;
      parametros.senhaBpo = senhaBpo;
      parametros.urlDigitalBpo = urlDigitalBpo;
      parametros.urlLecca = urlLecca;
      parametros.tokenLecca = tokenLecca;
      parametros.urlVortx = urlVortx;
      parametros.tokenVortx = tokenVortx;
      parametros.urlCessao = urlCessao;
      parametros.tokenCessao = tokenCessao;
      parametros.idOriginador = Number(idOriginador);
      parametros.chaveApiPh3a = chaveApiPh3a;
      parametros.serviceAccountIss = serviceAccountIss;
      parametros.urlDeAutenticacao = urlDeAutenticacao;
      parametros.urlApi = urlApi;

      parametros.integraS3 = integraS3;
      parametros.accessKeyS3 = accessKeyS3;
      parametros.secretKeyS3 = secretKeyS3;
      parametros.bucketS3 = bucketS3;
      parametros.pastaDocumentosS3 = pastaDocumentosS3;
      parametros.pastaComunicadosS3 = pastaComunicadosS3;
      parametros.localizacaoS3 = localizacaoS3;

      // Salvando dados do Gabarito S3
      parametros.tipoIntegracaoSecuritizadora = tipoIntegracaoSecuritizadora;
      parametros.accessKeyGabaritoS3 = accessKeyGabaritoS3;
      parametros.secretKeyGabaritoS3 = secretKeyGabaritoS3;
      parametros.bucketGabaritoS3 = bucketGabaritoS3;
      parametros.pastaDocumentosGabaritoS3 = pastaDocumentosGabaritoS3;
      parametros.pastaComunicadosGabaritoS3 = pastaComunicadosGabaritoS3;
      parametros.localizacaoGabaritoS3 = localizacaoGabaritoS3;

      // Salvando dados da Bancarizadora Gabarito
      parametros.cnpjBancarizadoraGabarito = cnpjBancarizadoraGabarito;
      parametros.nomeBancarizadoraGabarito = nomeBancarizadoraGabarito;
      parametros.agioOriginadorGabarito = agioOriginadorGabarito !== '' ? Number(agioOriginadorGabarito) : null;
      parametros.custoTedGabarito = custoTedGabarito !== '' ? Number(custoTedGabarito) : null;
      parametros.taxaBancarizadoraGabarito = taxaBancarizadoraGabarito !== '' ? Number(taxaBancarizadoraGabarito) : null;

      parametros.backoffice = backoffice;
      parametros.processadoraCartao = processadoraCartao;
      parametros.login_cpf = loginCpf;

      if (backoffice === 'FUNCAO') {
        parametros.usuarioFuncao = usuarioFuncao;
      }

      await parametrosService.alterarParametros(parametros);

      setLoading(false)
      setAlert({ message: 'Alteração realizada com sucesso!', type: 'success' });
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || err.message, type: 'error' });
    }
  };

  const testarConexaoS3 = async (e: any) => {
    e.preventDefault();
    if (integraS3 && (accessKeyS3 === '' || secretKeyS3 === '' || bucketS3 === '' || pastaDocumentosS3 === '' || pastaComunicadosS3 === '')) {
      setAlert({ message: 'Preencha todos os campos de credenciais da AWS', type: 'error' });
      return;
    }

    try {
      setLoading(true);
      let parametros: Parametros = new Parametros();
      parametros.integraS3 = integraS3;
      parametros.accessKeyS3 = accessKeyS3;
      parametros.secretKeyS3 = secretKeyS3;
      parametros.bucketS3 = bucketS3;
      parametros.pastaDocumentosS3 = pastaDocumentosS3;
      parametros.pastaComunicadosS3 = pastaComunicadosS3;
      parametros.localizacaoS3 = localizacaoS3;

      const response = await parametrosService.verificarConexaoS3(parametros);

      setLoading(false);
      setAlert({ message: response.data, type: 'success' });
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || err.message, type: 'error' });
    }
  };

  const listarOriginadores = async () => {
    try {
      const response = await originadorService.listarTodosOriginadoresAtivos();
      const data = response.data;
      setOriginadoresList(Array.isArray(data) ? data : []);

    } catch (err) {
      console.error("Erro ao buscar originadores", err);
      setAlert({ message: 'Não foi possível carregar a lista de originadores.', type: 'error' });
      setOriginadoresList([]);
    }
  }

  const handleCheckboxChange = () => {
    setIntegraS3(!integraS3);
    if (!integraS3) {
      setAccessKeyS3('');
      setSecretKeyS3('');
      setBucketS3('');
      setPastaDocumentosS3('');
      setPastaComunicadosS3('');
      setLocalizacaoS3('');
    }
  };

  useEffect(() => {
    listarTodosParametrosTi();
    listarOriginadores();
  }, []);

  return (
    <div className="position-relative m-md-3 container-fluid SiteFontSize">
      <div className="row col-md-12">
        <h6><strong>Sistema &gt; Parâmetros TI</strong></h6>
      </div>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>

          <div style={{ marginTop: '15px' }}>
            <h5>BackOffice</h5>
            <div className="col-md-6 form-group">
              <select className="form-select" style={{ backgroundColor: 'white', width: '40%', textAlignLast: 'center', marginTop: '10px' }}
                value={backoffice} onChange={(e) => setBackoffice(e.target.value)}
              >
                <option value="" disabled>{"Selecione uma opção"}</option>
                {backofficeEnum.map((item) => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Processadora Cartão</h5>
            <div className="col-md-6 form-group">
              <select
                className="form-select"
                style={{ backgroundColor: 'white', width: '40%', textAlignLast: 'center', marginTop: '10px' }}
                value={processadoraCartao}
                onChange={(e) => setProcessadoraCartao(e.target.value)}
              >
                <option value="" disabled>Selecione uma opção</option>
                {processadoraCartaoEnum.map((item) => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Tipo de Login</h5>
            <div className="col-md-6 form-group">
              <select
                className="form-select"
                style={{ backgroundColor: 'white', width: '40%', textAlignLast: 'center', marginTop: '10px' }}
                value={loginCpf}
                onChange={(e) => setLoginCpf(Number(e.target.value))}
              >
                <option value={0}>Usuário</option>
                <option value={1}>CPF</option>
              </select>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Integração BPO</h5>
            <div className="row">
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>Nome Banco BPO</span>
                <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={nomeBancoBpo} onChange={(e) => setNomeBancoBpo(e.target.value)}
                />
              </div>
              <div className="col-md-2 form-group">
                <span style={{ textAlign: 'left' }}>Usuário</span>
                <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={usuarioBpo} onChange={(e) => setUsuarioBpo(e.target.value)}
                />
              </div>
              <div className="col-md-2 form-group">
                <span style={{ textAlign: 'left' }}>Senha</span>
                <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={senhaBpo} onChange={(e) => setSenhaBpo(e.target.value)}
                />
              </div>
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>URL Serviço</span>
                <input type="url" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={urlBpo} onChange={(e) => setUrlBpo(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Integração Digital BPO</h5>
            <div className="row">
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>URL Serviço</span>
                <input type="url" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={urlDigitalBpo} onChange={(e) => setUrlDigitalBpo(e.target.value)}
                />
              </div>
            </div>
          </div>

          {REACT_APP_PERFIL !== 'QISTA' && REACT_APP_PERFIL !== 'FICTOR' && (
            <>
              <div style={{ marginTop: '15px' }}>
                <h5>Integração Lecca</h5>
                <div className="row">
                  <div className="col-md-6 form-group">
                    <span style={{ textAlign: 'left' }}>URL Serviço</span>
                    <input type="url" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                      value={urlLecca} onChange={(e) => setUrlLecca(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <span style={{ textAlign: 'left' }}>Token</span>
                    <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                      value={tokenLecca} onChange={(e) => setTokenLecca(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Título alterado conforme solicitado */}
              <div style={{ marginTop: '15px' }}>
                <h5>Tipo de Cessão</h5>
                <div className="col-md-6 form-group">
                  <select
                    className="form-select"
                    style={{ backgroundColor: 'white', width: '40%', textAlignLast: 'center', marginTop: '10px' }}
                    value={tipoIntegracaoSecuritizadora}
                    onChange={(e) => setTipoIntegracaoSecuritizadora(e.target.value)}
                  >
                    <option value="" disabled>Selecione uma opção</option>
                    {opcoesSecuritizadora.map((item) => (
                      <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Integração S3 Gabarito e Bancarizadora */}
              {tipoIntegracaoSecuritizadora === 'GABARITO' && (
                <div style={{ marginTop: '15px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                  <h5>Integração AWS S3 - Gabarito</h5>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>Access Key</span>
                      <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={accessKeyGabaritoS3} onChange={(e) => setAccessKeyGabaritoS3(e.target.value)} />
                    </div>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>Secret Key</span>
                      <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={secretKeyGabaritoS3} onChange={(e) => setSecretKeyGabaritoS3(e.target.value)} />
                    </div>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>Nome do Bucket</span>
                      <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={bucketGabaritoS3} onChange={(e) => setBucketGabaritoS3(e.target.value)} />
                    </div>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>Pasta Documentos S3</span>
                      <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={pastaDocumentosGabaritoS3} onChange={(e) => setPastaDocumentosGabaritoS3(e.target.value)} />
                    </div>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>Localização S3</span>
                      <select
                        className="form-control form-control-sm brds"
                        style={{ textAlign: 'left' }}
                        value={localizacaoGabaritoS3}
                        onChange={(e) => setLocalizacaoGabaritoS3(e.target.value)}
                      >
                        <option value="">Selecione uma região...</option>
                        <option value="us-gov-west-1">AWS GovCloud (US)</option>
                        <option value="us-gov-east-1">AWS GovCloud (US-East)</option>
                        <option value="us-east-1">US East (N. Virginia)</option>
                        <option value="us-east-2">US East (Ohio)</option>
                        <option value="us-west-1">US West (N. California)</option>
                        <option value="us-west-2">US West (Oregon)</option>
                        <option value="eu-west-1">EU (Ireland)</option>
                        <option value="eu-west-2">EU (London)</option>
                        <option value="eu-west-3">EU (Paris)</option>
                        <option value="eu-central-1">EU (Frankfurt)</option>
                        <option value="eu-north-1">EU (Stockholm)</option>
                        <option value="eu-south-1">EU (Milan)</option>
                        <option value="ap-east-1">Asia Pacific (Hong Kong)</option>
                        <option value="ap-south-1">Asia Pacific (Mumbai)</option>
                        <option value="ap-southeast-1">Asia Pacific (Singapore)</option>
                        <option value="ap-southeast-2">Asia Pacific (Sydney)</option>
                        <option value="ap-northeast-1">Asia Pacific (Tokyo)</option>
                        <option value="ap-northeast-2">Asia Pacific (Seoul)</option>
                        <option value="ap-northeast-3">Asia Pacific (Osaka)</option>
                        <option value="sa-east-1">South America (Sao Paulo)</option>
                        <option value="cn-north-1">China (Beijing)</option>
                        <option value="cn-northwest-1">China (Ningxia)</option>
                        <option value="ca-central-1">Canada (Central)</option>
                        <option value="me-south-1">Middle East (Bahrain)</option>
                        <option value="af-south-1">Africa (Cape Town)</option>
                        <option value="us-iso-east-1">US ISO East</option>
                        <option value="us-isob-east-1">US ISOB East (Ohio)</option>
                        <option value="us-iso-west-1">US ISO West</option>
                      </select>
                    </div>
                  </div>

                  <h5 style={{ marginTop: '20px' }}>Dados Bancarizadora (Gabarito)</h5>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-md-3 form-group">
                      <span style={{ textAlign: 'left' }}>CNPJ Bancarizadora</span>
                      <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={cnpjBancarizadoraGabarito} onChange={(e) => setCnpjBancarizadoraGabarito(e.target.value)} />
                    </div>
                    <div className="col-md-4 form-group">
                      <span style={{ textAlign: 'left' }}>Nome Bancarizadora</span>
                      <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={nomeBancarizadoraGabarito} onChange={(e) => setNomeBancarizadoraGabarito(e.target.value)} />
                    </div>
                    <div className="col-md-2 form-group">
                      <span style={{ textAlign: 'left' }}>Ágio Originador (%)</span>
                      <input type="number" step="0.01" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={agioOriginadorGabarito} onChange={(e) => setAgioOriginadorGabarito(e.target.value !== '' ? Number(e.target.value) : '')} />
                    </div>
                    <div className="col-md-2 form-group">
                      <span style={{ textAlign: 'left' }}>Custo TED (R$)</span>
                      <input type="number" step="0.01" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={custoTedGabarito} onChange={(e) => setCustoTedGabarito(e.target.value !== '' ? Number(e.target.value) : '')} />
                    </div>
                    <div className="col-md-3 form-group" style={{ marginTop: '10px' }}>
                      <span style={{ textAlign: 'left' }}>Taxa Bancarizadora (%)</span>
                      <input type="number" step="0.01" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={taxaBancarizadoraGabarito} onChange={(e) => setTaxaBancarizadoraGabarito(e.target.value !== '' ? Number(e.target.value) : '')} />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Integração VortX */}
          <div style={{ marginTop: '15px' }}>
            <h5>Integração VortX</h5>
            <div className="row">
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>URL Serviço</span>
                <input type="url" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={urlVortx} onChange={(e) => setUrlVortx(e.target.value)}
                />
              </div>
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>Token</span>
                <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={tokenVortx} onChange={(e) => setTokenVortx(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Integração Cessão</h5>
            <div className="row">
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>URL Serviço</span>
                <input type="url" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={urlCessao} onChange={(e) => setUrlCessao(e.target.value)}
                />
              </div>
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>Token</span>
                <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                  value={tokenCessao} onChange={(e) => setTokenCessao(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>Integração AWS S3 Principal</h5>

            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="integraS3" checked={integraS3} onChange={handleCheckboxChange} />
              <label className="form-check-label" htmlFor="integraS3">
                Ativar Integração AWS S3
              </label>
            </div>

            {integraS3 && (
              <>
                <div className="row" style={{ marginTop: '15px' }}>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Access Key</span>
                    <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={accessKeyS3} onChange={(e) => setAccessKeyS3(e.target.value)} />
                  </div>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Secret Key</span>
                    <input type="password" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={secretKeyS3} onChange={(e) => setSecretKeyS3(e.target.value)} />
                  </div>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Nome do Bucket</span>
                    <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={bucketS3} onChange={(e) => setBucketS3(e.target.value)} />
                  </div>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Pasta Documentos S3</span>
                    <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={pastaDocumentosS3} onChange={(e) => setPastaDocumentosS3(e.target.value)} />
                  </div>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Pasta Comunicados S3</span>
                    <input type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} value={pastaComunicadosS3} onChange={(e) => setPastaComunicadosS3(e.target.value)} />
                  </div>
                  <div className="col-md-3 form-group">
                    <span style={{ textAlign: 'left' }}>Localização S3</span>
                    <select
                      className="form-control form-control-sm brds"
                      style={{ textAlign: 'left' }}
                      value={localizacaoS3}
                      onChange={(e) => setLocalizacaoS3(e.target.value)}
                    >
                      <option value="">Selecione uma região...</option>
                      <option value="us-gov-west-1">AWS GovCloud (US)</option>
                      <option value="us-gov-east-1">AWS GovCloud (US-East)</option>
                      <option value="us-east-1">US East (N. Virginia)</option>
                      <option value="us-east-2">US East (Ohio)</option>
                      <option value="us-west-1">US West (N. California)</option>
                      <option value="us-west-2">US West (Oregon)</option>
                      <option value="eu-west-1">EU (Ireland)</option>
                      <option value="eu-west-2">EU (London)</option>
                      <option value="eu-west-3">EU (Paris)</option>
                      <option value="eu-central-1">EU (Frankfurt)</option>
                      <option value="eu-north-1">EU (Stockholm)</option>
                      <option value="eu-south-1">EU (Milan)</option>
                      <option value="ap-east-1">Asia Pacific (Hong Kong)</option>
                      <option value="ap-south-1">Asia Pacific (Mumbai)</option>
                      <option value="ap-southeast-1">Asia Pacific (Singapore)</option>
                      <option value="ap-southeast-2">Asia Pacific (Sydney)</option>
                      <option value="ap-northeast-1">Asia Pacific (Tokyo)</option>
                      <option value="ap-northeast-2">Asia Pacific (Seoul)</option>
                      <option value="ap-northeast-3">Asia Pacific (Osaka)</option>
                      <option value="sa-east-1">South America (Sao Paulo)</option>
                      <option value="cn-north-1">China (Beijing)</option>
                      <option value="cn-northwest-1">China (Ningxia)</option>
                      <option value="ca-central-1">Canada (Central)</option>
                      <option value="me-south-1">Middle East (Bahrain)</option>
                      <option value="af-south-1">Africa (Cape Town)</option>
                      <option value="us-iso-east-1">US ISO East</option>
                      <option value="us-isob-east-1">US ISOB East (Ohio)</option>
                      <option value="us-iso-west-1">US ISO West</option>
                    </select>
                  </div>
                </div>
              </>
            )}
          </div>

          <div style={{ marginTop: '15px' }}>
            <h5>{Originador.DESCRITIVO_GERAL}</h5>
            <div className="row" style={{ marginTop: '15px' }}>
              <div className="col-md-6 form-group">
                <span style={{ textAlign: 'left' }}>Selecione a {Originador.DESCRITIVO_GERAL}</span>
                <select
                  className="form-select form-select-sm brds"
                  value={idOriginador}
                  onChange={(e) => setIdOriginador(e.target.value)}
                >
                  <option value="">Selecione uma opção</option>
                  {Array.isArray(originadoresList) && originadoresList.map((originador) => (
                    <option key={originador.id} value={originador.id}>
                      {originador.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row" style={{ marginTop: '15px' }}>
              <div className="col-md-3 form-group">
                <span style={{ textAlign: 'left' }}>Chave API PH3A</span>
                <input type="password" className="form-control form-control-sm brds" value={chaveApiPh3a} onChange={(e) => setChaveApiPh3a(e.target.value)} />
              </div>
              <div className="col-md-3 form-group">
                <span style={{ textAlign: 'left' }}>Service Account Iss</span>
                <input type="password" className="form-control form-control-sm brds" value={serviceAccountIss} onChange={(e) => setServiceAccountIss(e.target.value)} />
              </div>
              <div className="col-md-3 form-group">
                <span style={{ textAlign: 'left' }}>URL De Autenticação</span>
                <input type="text" className="form-control form-control-sm brds" value={urlDeAutenticacao} onChange={(e) => setUrlDeAutenticacao(e.target.value)} />
              </div>
              <div className="col-md-3 form-group">
                <span style={{ textAlign: 'left' }}>URL API</span>
                <input type="text" className="form-control form-control-sm brds" value={urlApi} onChange={(e) => setUrlApi(e.target.value)} />
              </div>
            </div>
          </div>

          {backoffice === 'FUNCAO' && (
            <div style={{ marginTop: '15px' }}>
              <h5>Usuário Função</h5>
              <div className="col-md-6 form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Digite aqui..."
                  value={usuarioFuncao}
                  onChange={(e) => setUsuarioFuncao(e.target.value)}
                />
              </div>
            </div>
          )}

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <ProtectedAction>
                <button className="w-40 btn btn-lg" id="App-button-cor-principal" onClick={(e) => { e.preventDefault(); window.history.back(); }}>Voltar</button>
                <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">Salvar Parâmetros</button>
              </ProtectedAction>
            </div>
          </div>

        </form>
      )}
    </div>
  );
}
export default ParametrosTi;